const en = {
  on: {
    useSafari: 'Please use Safari to open this link',
    callApp: 'Call App'
  },
  order: {
    orderDetails: 'Order Details',
    acceptedOrder: 'You accepted the order',
    orderCompleted: 'Order completed',
    Confirmorder: 'Confirm to take the order?',
    Ordercanceled: 'Order was canceled',
    Rejectorder: 'Reject the order?',
    Rejectcancellation: 'Reject the cancellation request?',
    OnceConfirmorder:
      'Once you take the order, it can not be initiatively canceled by you. Confirm to take the order?',
    responseto: 'You didn’t response to',
    automaticallycanceled:
      '’s order within 24 hours. Thus the order was automatically canceled.',
    Yes: 'Yes',
    cancelOrder: 'Cancel the Order',
    thinkAgain: 'Think again',
    Orderconfirmed: 'Order confirmed',
    rejectorder:
      'Once you reject the order, it will be canceled immediately. Still reject the order?',
    Orderrejected: 'Order rejected',
    rejectcancellation:
      'Once you reject the cancellation request, the order will be in dispute and officially arbitrated. Still reject the cancellation request?',
    Successful: 'Successful',
    Successfully: 'Successfully',
    acceptcancellation:
      'Once you accept the cancellation request, the order will be canceled immediately. Still accept the cancellation request?',
    Reject: 'Reject',
    Confirming: 'Confirming',
    inProgress: 'In Progress',
    cancellationRequest: 'Cancellation Request',
    Dispute: 'Dispute',
    Confirm: 'Confirm',
    completed: 'Completed',
    acceptedorder: 'accepted your order',
    Writereview: 'Write a review',
    Tapstars:
      "Tap the stars to leave your review! Your review will improve the master's performance.",
    Surecancelorder: 'Sure to cancel the order?',
    Surecompleteorder: 'Sure to complete the order?',
    reachedagreement:
      'Please make sure you’ve reached an agreement with your master before the cancellation.',
    permenantlyclosed:
      'The order will be permenantly closed once you cancel it.',
    completeorder:
      'Once you complete the order, the money cannot be charged back.',
    confirmacceptorder: 'confirm accept current order ?',
    Order: 'Order',
    canceled: 'Canceled',
    Play: 'Play',
    with: 'with',
    Quantity: 'Quantity',
    Subtotal: 'Subtotal',
    Total: 'Total',
    purchaseSkill: 'Purchase Skill',
    Note: 'Note',
    CompleteOrder: 'Complete the Order',
    Orders: 'Orders',
    myorder: 'My Orders',
    Received: 'Received',
    Placed: 'Placed',
    Acceptcancellation: 'Accept the cancellation request?'
  },
  follow: {
    FollowList: 'Follow List',
    Following: 'Following',
    Follower: 'Follower',
    follow: 'Follow',
    Followers: 'Followers',
    followyourself: 'Can not follow yourself',
    unfollow: 'Are you sure you want to unfollow',
    tokenLost: 'Token Lost',
    noPlayerID: 'No PlayerID',
    End: 'End',
    nofollowers: 'No followers yet',
    nofollowing: 'No following gamers yet'
  },
  player: {
    wirteReview: 'Write a Review',
    Review: 'Review',
    Reviews: 'Reviews',
    SeeMore: 'See More',
    Skills: 'Skills',
    localtime: 'local time',
    Buy: 'Buy',
    gamers: 'Gamers',
    moreSkills: 'More Skills',
    findGamers: 'Find Amazing Gamers',
    noratings: 'There are no ratings or reviews yet.',
    SeeAll: 'See All',
    Showmore: 'Show us more about yourself!',
    suchempty: 'Wow,such empty',
    editprofile: 'Edit profile',
    Followed: 'Followed',
    Unfollow: 'Unfollow',
    Cancel: 'Cancel'
  },
  skill: {
    Add: 'Add',
    Skills: 'Skills',
    finishSetting: 'Finish Setting',
    Verifying: 'Verifying',
    Level: 'Level',
    Rating: 'Rating',
    Whoops: 'Whoops',
    OK: 'OK',
    Withdraw: 'Withdraw',
    Noconnection:
      'No internect connection.Please check your internet settings.',
    tryAgain: 'Try Again',
    Price: 'Price',
    pricePer: 'Price Per',
    Earnings: 'Earnings',
    hourserved: 'Hour served',
    Transactions: 'Transactions',
    orderTaking: 'Order Taking',
    onlyWithDraw:
      'Your earnings can only ly be withdrawn after a 30-day clearance.'
  },
  record: {
    contactus: 'Contact Us',
    ResolutionCenter: 'Resolution Center',
    Pendingclearance: 'Pending clearance',
    sentemail: 'Make sure you’ve sent the email',
    Clearance: 'Clearance',
    Hi: 'Hi',
    Sent: 'I’ve Sent the Email',
    example: 'Here is an example.',
    morehelp:
      'Guess you need more help or you want us to do better with some feedback. Please feel free to contact us by email. You will get our relply within 72 hours. Our Email address is',
    Game: 'Game',
    SendEmail: 'Send Email Right Now',
    rejectedcancellation:
      'Since you rejected the cancellation request, please send us an Email, writing down the reason and uploading files by attachment to support your side of view. You will get our relply within 72 hours. Our Email address is',
    applyingcancel:
      'Since you are applying to cancel the order, please send us an Email, writing down the reason and uploading files by attachment to support your view. You will get our relply within 72 hours. Our Email address is',
    OrderID: 'Order ID',
    Copy: 'Copy',
    Totalprice: 'Total price',
    name: 'name',
    Withdrawn: 'Withdrawn',
    Availabletowithdraw: 'Available to withdraw',
    amountofevery: '3. The maximum amount of every withdraw is $5,000.',
    onlywithdrawonce: '2. You can only withdraw once every 24 hours.',
    Yourearningscan:
      '1. Your earnings can only be withdrawn after a 7-day clearance.',
    reviewthecase:
      "Make sure you've sent the email and Teamup will review the case.",
    stepinthease:
      "Make sure you've sent the email and Teamup will step in the case.",
    canwithdraw:
      'Every transaction will go through a 7-day clearance before you can withdraw.'
  },
  login_title: 'Invite me if you want to play games',
  login_facebook: 'Facebook Login',
  login_line: 'LINE Login',
  login_google: 'Google Login',
  login_other: 'Other Login Methods',
  login_phone: 'Phone Number Login',
  login_agree:
    'Login means you agree to the nicee User Agreement and Privacy Policy',
  login_smscode: 'Get Verification Code',
  login_now: 'Login Now',
  home_index: 'Home',
  home_feed: 'Trends',
  home_express_book: 'Rapid Appointments',
  home_message: 'Messages',
  home_my: 'Mine',
  home_recommended: 'Recommendations',
  home_lol: 'League of Legends',
  home_duel: 'Arena of Valor',
  home_voice_chat: 'Voice Communication',
  home_battle_canyon: 'Wild Rift',
  home_pubg: 'PUBG',
  home_small_alarm: 'Alarm Clock',
  home_rankings: 'Leaderboard',
  home_top_players: 'Daily Gathering of Pros',
  home_voice_room: 'Voice Room',
  home_input_nick: 'Please enter nickname/ID/game skill',
  home_cancel: 'Cancel',
  home_skill_names: 'Various skill names',
  home_pull_more: 'Pull down to summon more companions',
  home_release_more: 'Release to summon more companions',
  home_loading: 'Loading',
  gamelol: 'League of Legends',
  gamelol_order_king: 'Order King',
  gamelol_rank_up: 'Essential for scoring',
  gamelol_self_pic: 'This photo certification',
  gamelol_filter: 'Filter',
  gamelol_week_star: 'League Star of the Week',
  gamelol_sort: 'Sort',
  gamelol_synthesize_sort: 'Comprehensive sorting',
  gamelol_new_sort: 'Newcomers first',
  gamelol_high_sort: 'High price first',
  gamelol_low_sort: 'Low price first',
  gamelol_gender: 'Gender',
  gamelol_female: 'Female',
  gamelol_male: 'Male',
  gamelol_label: 'Tags',
  gamelol_first_discount: 'First order discount',
  gamelol_buzzworthy: 'Popular reputation',
  gamelol_high_popular: 'High popularity',
  gamelol_high_new: 'Quality newcomer',
  gamelol_7_minute: '7-minute taste',
  gamelol_expert_guiding: 'God takes off',
  gamelol_language_support: 'Language companion',
  gamelol_tier: 'Rank',
  gamelol_elite: 'Elite',
  gamelol_grand_master: 'Grandmaster',
  gamelol_master: 'Master',
  gamelol_diamond: 'Diamond',
  gamelol_platinum: 'Platinum',
  gamelol_expert_position: 'Good at position',
  gamelol_top_lang: 'Top lane',
  gamelol_jungle: 'Jungle',
  gamelol_mid_lang: 'Mid lane',
  gamelol_adc: 'ADC',
  gamelol_support: 'Support',
  gamelol_price: 'Price',
  gamelol_clear_filter: 'Clear filter',
  gamelol_complete: 'Done',
  gameduel: 'Arena of Valor',
  gameduel_week_star: 'Legend Star of the Week',
  gameduel_tier: 'Rank',
  gameduel_eternal_legend: 'Eternal Legend',
  gameduel_battlefield_legend: 'Battlefield Legend',
  gameduel_starlight: 'Starlight',
  gameduel_diamond: 'Diamond',
  gameduel_platinum: 'Platinum',
  gamevoice: 'Language Exchange',
  gamevoice_week_star: 'Music Star of the Week',
  gamevoice_tier: 'Rank',
  gamevoice_mom_voice: 'Mom’s voice',
  gamevoice_queen_mom: 'Royal mom’s voice',
  gamevoice_queen_sister: 'Royal sister’s voice',
  gamevoice_queen_little: 'Young royal voice',
  gmaevoice_girl_little: 'Girl’s voice',
  gmaevoice_luoli_little: 'Young loli voice',
  gamevoice_luoli: 'Loli voice',
  gamevoice_shou: 'Uke voice',
  gamevoice_uncle: 'Uncle voice',
  gamevoice_youth: 'Youth voice',
  gamevoice_youth_shou: 'Youth uke voice',
  gamevoice_youth_uncle: 'Youth uncle voice',
  gamevoice_live: 'Live host',
  gamebattle: 'Wild Rift',
  gamebattle_week_star: 'General game Star of the Week',
  gamebattle_tier: 'Rank',
  gamebattle_elite: 'Elite',
  gamebattle_grand_master: 'Grandmaster',
  gamebattle_master: 'Master',
  gamebattle_diamond: 'Diamond',
  gamebattle_emerald: 'Jade',
  gamebattle_platinum: 'Platinum',
  gamehero: 'Special Warfare Hero',
  gamehero_tier: 'Rank',
  gamehero_soul: 'Radiation Soul',
  gamehero_myth: 'Myth',
  gamehero_diamond: 'Diamond',
  gamehero_platinum: 'Platinum',
  gamehero_gold: 'Gold',
  gamehero_silver: 'Silver',
  gameapex: 'APEX',
  gameapex_tier: 'Rank',
  gameapex_hunter: 'APEX Predator',
  gameapex_master: 'Master',
  gameapex_diamond: 'Diamond',
  gameapex_platinum: 'Platinum',
  gamenaraka: 'Eternal Abyss',
  gamenaraka_tier: 'Rank',
  gamenaraka_abadi: 'Abyss Asura',
  gamenaraka_bulan: 'Eclipse',
  gamenaraka_jatuh: 'Meteor',
  gamenaraka_platinum: 'Platinum',
  all_skills: 'All Skills',
  normalskill: 'Common Skills',
  mbgame: 'Mobile Games',
  mbgame_duel: 'Arena of Valor',
  mbgame_battle: 'Wild Rift',
  mbgame_kart: 'KartRider Rush+',
  mbgame_live: 'I Want to Survive',
  mbgame_pubg: 'PUBG Mobile',
  mbgame_speed: 'Speed Domain',
  mbgame_cn_pubg: 'Peace Elite',
  mbgame_tomorrow: 'The Day After Tomorrow',
  mbgame_knives_out: 'Wilderness Action',
  mbgame_close_eye: 'Please Close Your Eyes When It’s Dark',
  mbgame_five: 'Identity V',
  mbgame_auto_chess: 'Auto Chess',
  mbgame_royale: 'Clash Royale',
  mbgame_bnb: 'Bomb King M',
  mbgame_super_star: 'Three Missing One Star',
  mbgame_dunk: 'Slam Dunk',
  mbgame_glory: 'Honor of Kings',
  mbgame_sky: 'Sky: Children of the Light',
  mbgame_impact: 'Genshin Impact',
  mbgame_ro: 'RO New Generation',
  mbgame_tom: 'Tom and Jerry: Chase',
  mbgame_duty: 'Call of Duty Mobile',
  mbgame_palyer: 'Play Every Day',
  pcgame_lol: 'League of Legends',
  pcgame_battle: 'Special Warfare Hero',
  pcgame_apex: 'APEX',
  pcgame_naraka: 'Eternal Abyss',
  pcgame_tft: 'Teamfight Tactics',
  pcgame_pubg: 'PUBG',
  pcgame_among: 'Werewolf in Space',
  pcgame_pubg_lite: 'PUBG Lite',
  pcgame_duty: 'Call of Duty',
  pcgame_dota2: 'DOTA 2',
  pcgame_csgo: 'CSGO',
  pcgame_division2: 'The Division 2',
  pcgame_six_siege: 'Rainbow Six',
  pcgame_fortite: 'Fortnite',
  pcgame_overwatch: 'Agents of Mayhem',
  pcgame_flat: 'Human: Fall Flat',
  pcgame_world: 'Minecraft',
  pcgaame_monster_world: 'Monster Hunter: World',
  pcgame_bnb: 'Bomb King',
  pcgame_ring: 'Infinite Rule',
  pcgame_dead: 'Dawn Deadlock',
  pcgame_exile: 'Path of Exile',
  pcgame_war: 'World of Warcraft',
  pcgame_maplestory: 'MapleStory',
  pcgame_rust: 'Rust',
  pcgame_monopoli: 'Monopoly',
  pcgame_overcooked: 'Overcooked',
  pcgame_hearthstone: 'Hearthstone',
  pcgame_gtav: 'GTA V',
  pcgame_warframe: 'Warframe',
  pcgame_knockout: 'Fall Guys',
  pcgame_super_animal: 'Super Animal Royale',
  pcgame_hunter_rise: 'Monster Hunter Rise',
  pcgame_double: 'It Takes Two',
  pcgame_diablo4: 'Diablo 4',
  pcgame_animal_crossing: 'Animal Crossing',
  gamevoice_lover: 'Virtual Lover',
  gamevoice_good: 'Good Voice',
  gamevoice_no_sleep: 'Insomnia Companion',
  gamevoice_alarm: 'Alarm Clock',
  gamevoice_film_online: 'Watch Movies Online',
  gamevoice_ask: 'Emotional Counseling',
  status: 'Trends',
  status_newest: 'Recent',
  status_recommend: 'Recommended',
  status_track: 'Track',
  status_just: 'Just Published',
  status_comment: 'Comment Now, Join the Discussion',
  status_like: 'Like',
  status_push_new: 'Post Trends',
  status_push: 'Post',
  status_share: 'Share your mood today',
  status_input: 'Click to enter topic (limited to 10 words)',
  status_link: 'Click to set related skills',
  quickorder: 'Rapid Appointments',
  quickorder_progress: 'Ongoing Appointments',
  quickorder_find: 'Looking for a companion',
  quickorder_report: 'Report',
  quickorder_grab: 'x companions are grabbing orders',
  quickorder_grab_time: 'Countdown to grab orders',
  quickorder_complete: 'Completed Appointments',
  quickorder_record: 'Only keep the last 10 appointment records',
  quickorder_want: 'What kind of companion do you want to find?',
  quickorder_remark: 'Note (optional): For example, “nice voice”, etc.',
  myorder: 'My Orders',
  myorder_want: 'What kind of companion do you want to find?',
  myorder_lol: 'League of Legends, mode and position not limited',
  myorder_sex: 'Gender not limited',
  myorder_price: 'Price not limited',
  myorder_count: 'Quantity (rounds)',
  order_complete: 'Confirm Order',
  order_billing_mode: 'Billing Mode',
  order_billing_mode_choose: 'Select Billing Mode',
  order_normal_mode: 'Standard Mode',
  order_by_count: 'Purchase Quantity',
  order_discount: 'Coupon',
  order_none: 'None available',
  order_fist_discount: 'First Order Discount',
  order_sum: 'Total',
  order_total_pay: 'Total Payment Amount',
  message: 'Messages',
  message_line: 'Bind Line notification, don’t miss any messages',
  message_system: 'System Notification',
  message_house_keeper: 'Member Housekeeper',
  message_limit_activity: 'Limited Time Activity',
  message_guard: 'Guardian System',
  message_none: 'No messages yet',
  chat_share: 'Share',
  chat_block: 'Block',
  chat_report: 'Report',
  chat_cancel: 'Cancel',
  chat_hi: 'Hello, how are you?',
  chat_hope: 'Are you free now? (Looking forward to~',
  chat_ok: 'Good, good!',
  chat_play: 'Come for a game?',
  chat_next: 'Can we make an appointment another day?',
  chat_some: 'Say something~',
  chat_send: 'Send',
  report: 'Report',
  report_reason: 'Select the reason for the report',
  report_harassment: 'Send false and harmful information to harass users',
  report_fake: 'False personal information',
  report_violation: 'Use illegal means to place or accept orders',
  report_no_order: 'The companion does not accept orders',
  report_private_order: 'Private order report (reward for verification)',
  report_other: 'Other violations',
  report_picture: 'Please upload picture evidence',
  report_5_pic: 'Required, please upload up to 5 clear related materials',
  report_push: 'Submit',
  please_fill_in_review_content: 'Please fill in the review content',
  profile: 'Mine',
  profile_nicee: 'Gold',
  profile_diamond: 'Diamond',
  profile_candy: 'Candy',
  profile_discount: 'Coupon',
  profile_history: 'View Historical Orders',
  profile_orders: 'My Orders',
  profile_gifts: 'My Gifts',
  profile_see: 'I’ve Seen',
  profile_fllow: 'My Tracking',
  profile_dressup: 'Dress Up',
  profile_invite: 'Invite',
  profile_customer: 'Customer Service',
  profile_setting: 'Settings',
  profile_player: 'Mine (Companion Panel)',
  profile_income: 'Income',
  profile_exchange: 'Exchange/Gift',
  profile_skills: 'Skills',
  profile_feed: 'Trends',
  profile_client: 'Customers',
  profile_visit: 'Recent Visitors',
  profile_self_promotion: 'Self-promotion',
  profile_fans: 'My Fans',
  profile_total_rating: 'Comprehensive Score',
  profile_voice_room: 'My Voice Room',
  material: 'Information',
  material_edit: 'Edit Information',
  material_photo: 'My Album',
  material_more_photo: 'You can upload 9 pictures to show us more about you',
  material_lan_desc: 'Add Language Introduction',
  material_self_dec: 'Add Self-introduction',
  material_sex: 'Gender',
  material_birthday: 'Birthday',
  material_address: 'Residence',
  material_mars: 'Mars',
  material_guard: 'Guardian',
  material_null: 'Vacant',
  material_guard_amount: 'The current initial guardian amount is set to 750',
  material_fisrt_guard: 'First Screen Guardian Special Position',
  material_special: 'Exclusive Avatar Frame',
  material_comment: 'Comment Area Nickname Highlight',
  material_self_desc: 'Self-introduction',
  material_guard_amount_set: 'Set Initial Guardian Amount',
  material_cancel: 'Cancel',
  material_save: 'Save',
  material_content_null: 'Wow, it’s so empty here~',
  material_self_profile: 'Personal Information',
  material_feed: 'Trends',
  maerial_feed_push: 'Post Trends',
  material_no_feed: 'Haven’t posted any trends yet~',
  level_desc: 'Level Description',
  level_now: 'Current Level',
  level_normal: 'Ordinary Member',
  level_month: 'Need to spend 1 more this month to upgrade to VIP1',
  level_benefits: 'Level Benefits',
  member_exclusive_skin: 'Member Exclusive Dress Up',
  unlock_with_1688_spending: 'Unlock when monthly consumption reaches 1688',
  exclusive_avatar_frame:
    'Includes exclusive avatar frame, bubble frame, entrance banner',
  monthly_10_coin_voucher: '1 10-coin coupon every month',
  no_minimum_spending_requirement:
    'No consumption threshold, issued on the 1st of each month',
  upgrade_pending: 'To be upgraded',
  diamond_member: 'Diamond Member',
  sparkling_fireworks_avatar_frame: '“Gorgeous Fireworks” Avatar Frame',
  sparkling_stars_avatar_frame: '“Dazzling Stars” Avatar Frame',
  dream_car_mount: '“Dream Sports Car” Mount',
  white_tiger_avatar_frame: '“White Tiger” Avatar Frame',
  extreme_car_mount: '“Extreme Sports Car” Mount',
  black_gold_member: 'Black Gold Member',
  qilin_avatar_frame: '“Kirin” Avatar Frame',
  white_tiger_mount: '“White Tiger” Mount',
  crystal_shine_avatar_frame: '“Crystal Shine” Avatar Frame',
  qilin_mount: '“Kirin” Mount',
  exclusive_gift_pyramid: 'Exclusive Gift “Pyramid”',
  legendary_member: 'Legendary Member',
  diamond_chest_available_this_month: 'Can receive a diamond box this month',
  current_defense_attempts: 'Current number of retention times',
  not_met_requirements: 'Not up to standard',
  cancel_10_quick_dates_per_month:
    'Can actively cancel 10 rapid appointments per month',
  free_defense_privilege: 'Can enjoy free retention privilege',
  specify_5_recommended_privileges:
    'Can designate a companion to be recommended 5 times',
  legend_avatar_frame: '“Legend” Avatar Frame',
  phoenix_mount: '“Phoenix” Mount',
  exclusive_gift_sky_city: 'Exclusive Gift “City in the Sky”',
  specify_1_app_cover_privilege:
    'Can designate a companion to be on the APP cover once a month',
  king_legend_avatar_frame: '“King of Legends” Avatar Frame',
  dragon: '“Dragon” Mount',
  exclusive_gift_legend_throne: 'Exclusive Gift “Legendary Throne”',
  levelrule: 'Level Rules',
  levelrule_1:
    'Validity Calculation: From the time the level is obtained, the level identity is valid until the end of the next month.',
  levelrule_2:
    'Example: If a user obtains level VIP5 on February 5, then the VIP5 expiration date is March 31, and the level is recalculated on April 1.',
  levelrule_3:
    'Level Upgrade: Users can upgrade their level through consumption (orders, gift consumption). When regular consumption meets the upgrade conditions, a new level will be obtained on the same day, and the new level expiration date is from the upgrade date to the end of the next month.',
  levelrule_4:
    'Example: If a user is VIP5 on February 5, and reaches VIP6 through consumption on February 6, then the VIP6 validity period is 2.06-3.31.',
  levelrule_5:
    'Retain Level: If a user already has a certain level, if the consumption in the expired month reaches 70% of the current level requirement consumption amount, the level can be retained.',
  levelrule_6:
    'Example: The user’s regular level is VIP11 on February 5. Assuming the 11th level consumption amount point is 100000, the validity period is until 3.31, then the renewal needs to reach 70000 yuan before April 1, then the level can be retained next month.',
  levelrule_7:
    'Level Downgrade: In the month when the user’s level expires, if the consumption amount does not reach the retention level requirement of the corresponding level, the level will be reduced in the next settlement month. If the consumption amount of the retention level requirement of the current corresponding level is not completed next month, the level will be reduced again, and so on.',
  levelrule_8:
    'Example: If a user is VIP5 on February 5, if the consumption does not reach 70% of the consumption amount required by VIP5 and VIP4 before the end of the settlement month (March), but reaches 70% of the consumption amount required by VIP3, then the user will be downgraded to VIP3 starting April 1.',
  retention_privilege: 'Retention Privilege',
  retention_privilege_1:
    'If the current consumption is not enough to retain the level, you can use a “Retention Privilege” once to continue to retain the member level until the end of the next month. At the beginning of the month after next, whether the member level is retained needs to be settled based on the user’s consumption situation during the settlement month and the retention period to decide whether to retain the level. “Retention Privilege”: Every time you maintain the member level for three consecutive months, you can get a “Retention Privilege” opportunity.',
  retention_privilege_2: 'Maximum of 2 times',
  retention_privilege_3: 'Cannot be used for two consecutive months',
  retention_privilege_4:
    'If you drop a level and return to SVIP1, SVIP2 or used “Retention Privilege” last month, the number of consecutive months to maintain the level will be recalculated.',
  retention_privilege_5:
    'If a user is promoted to a higher level member without using the retention privilege, the number of retention times will be reduced by 1.',
  retention_privilege_6: 'Designate a companion to be recommended',
  retention_privilege_7:
    'Every month, you can recommend a designated companion to a recommended position at a certain time, and configure it as a special identification for the recommended companion (the duration of a single recommendation is 6 hours)',
  retention_privilege_8: 'Designate a companion to be on the APP cover',
  retention_privilege_9:
    'Every month, you can recommend a companion to be on the official exclusive app cover once. After the recommendation, all users will browse the exclusive cover of the companion you recommended when they open the app.',
  recharge: 'Recharge',
  recharge_1: 'Limited Time Activity: Summer Carnival Big Giveaway',
  recharge_2: 'Recharge Account ID',
  recharge_3: 'Nickname',
  recharge_4: 'Select Amount',
  recharge_5: 'Select Payment Method',
  recharge_6: 'Credit Card (Visa/MasterCard/UnionPay/AmEx)',
  recharge_7: 'Credit Card (Visa/MasterCard/JCB)',
  recharge_8: 'ATM Transfer',
  recharge_9: 'Supermarket Code',
  recharge_10: 'PayPal',
  recharge_11: 'Confirm Recharge',
  discount: 'Coupon',
  discount_1: 'Redeem Coupon',
  discount_2: 'No Coupons',
  discount_3: 'Invalid Coupons',
  discount_4: 'Confirm Redemption',
  discount_5: 'Please enter the redemption code',
  discount_6: 'Click to enter the redemption code',
  discount_7: 'Redeem Now',
  myorder_1: 'Order Tutorial',
  myorder_2: 'All Orders',
  myorder_3: 'Ongoing Orders',
  myorder_4: 'Historical Orders',
  myorder_5: 'No Orders',
  orderdetail: 'Order Details',
  orderdetail_1: 'Order Number',
  orderdetail_2: 'Cancelled',
  orderdetail_3: 'Total Gifts',
  orderdetail_4: 'Quantity',
  orderdetail_5: 'Place Order',
  orderdetail_6: 'Order Cancelled',
  gifts: 'Gift',
  gifts_1: 'Received Gifts',
  gifts_2: 'You haven’t received any gifts yet, keep up the good work~',
  gifts_3: 'Sent Gifts',
  gifts_4: 'You haven’t sent any gifts yet~',
  dressup_center: 'Avatar Frame',
  dressup_center_1: 'Bubble Frame',
  dressup_center_2: 'Entrance Banner',
  dressup_center_3: 'Mount',
  dressup_center_4: 'Blooming Love',
  dressup_center_5: 'Blooming Heart',
  dressup_center_6: 'Green Valentine’s Day Event',
  dressup_center_7: 'Annual Champion',
  dressup_center_8: 'Annual Runner-up',
  dressup_center_9: 'Annual Third Place',
  dressup_center_10: 'Annual Top Eight',
  dressup_center_11: 'Annual Boss',
  dressup_center_12: 'Annual Event',
  dressup_center_13: 'Red Turf Stadium',
  dressup_center_14: 'Blue Turf Battlefield',
  dressup_center_15: 'World Cup Event',
  dressup_center_16: 'Order Weekly Leaderboard',
  dressup_center_17: 'Order Leaderboard Weekly Champion',
  dressup_center_18: 'Sweet Dad',
  dressup_center_19: 'Sweet Baby',
  dressup_center_20: 'Father’s Day Event',
  dressup_center_21: 'Dragon Boat',
  dressup_center_22: 'Good Zongzi',
  dressup_center_23: 'Dragon Boat Festival Event',
  dressup_center_24: 'Moving Voice',
  dressup_center_25: 'Waiting for You',
  dressup_center_26: 'Enter the Heart with a Song Event',
  dressup_center_27: 'Angel’s Love',
  dressup_center_28: 'Crystal Love',
  dressup_center_29: 'Love Points Race Event',
  apply_for_settlement: 'Apply for Entry',
  apply_for_settlement_1: 'nicee Companion invites you to become our companion',
  apply_for_settlement_2: 'We are waiting for you',
  apply_for_settlement_3:
    'Humorous, love to chat; love games, and also love to make friends.',
  apply_for_settlement_4:
    'Whether out of curiosity or profession, I hope to do a good job as a companion.',
  apply_for_settlement_5:
    'If you are such a person, quickly click to apply for entry and start your journey as a companion!',
  apply_for_settlement_6:
    'I have read and agree to the “nicee Companion Behavior Code” “Service Agreement and Privacy Regulations”',
  apply_for_settlement_7: 'Apply Now',
  invite: 'Invitation',
  invite_1: 'Up to 66 days of commission rewards',
  invite_2: 'Invite friends to draw for a generous cash prize',
  invite_3: 'Share',
  invite_4: 'Draw once, 0 chances left',
  invite_5: 'Draw 10 times, 0 chances left',
  invite_6: 'Thank you for your patronage',
  invite_7: 'My invitation code',
  invite_8: 'Click to copy',
  invite_9:
    'For each friend you invite to bind the invitation code, you can get 1 chance to draw a prize',
  invite_10:
    'For every 1000 nicee coins your bound friend stores, you can get 1 chance to draw a prize',
  invite_11: 'Currently accumulated',
  invite_12:
    'nicee coins have been automatically recharged to your wallet (withdrawn to your available income)',
  invite_13: 'My activity record',
  invite_14: 'No record yet, go invite friends to register',
  invite_15: 'Bind friend’s invitation code',
  invite_16:
    'I am a friend invited to register, bind the friend’s invitation code to help the friend get the chance to draw',
  niceebot: 'nicee Smart Robot',
  niceebot_1:
    'I am a nicee smart robot, what do you need to consult? Please describe the problem you encountered~',
  niceebot_2: 'Have you encountered the following problems:',
  niceebot_3: 'What is my nicee ID?',
  niceebot_4: 'How to apply to become a companion?',
  niceebot_5: 'How to apply for skills? What materials need to be provided?',
  niceebot_6: 'How to make a sound card?',
  niceebot_7: 'How to calculate the completion of the order?',
  niceebot_8: 'What should I do if there is a dispute in the order?',
  niceebot_9: 'Where can I grab the order?',
  niceebot_10: 'How to store value?',
  niceebot_11:
    'What should I do if the balance does not change 30 minutes after successful payment?',
  niceebot_12: 'How to convert the income of the companion into cash?',
  niceebot_13: 'Why can’t my avatar pass the audit?',
  niceebot_14:
    'I didn’t see the button of the customer service assistant or the new function released by the official. Is the system broken?',
  niceebot_15: 'Where to apply for this photo certification?',
  niceebot_16:
    'Please describe your problem in one sentence, as brief as possible^^',
  niceebot_17: 'Send',
  niceebot_18: 'Warm reminder',
  niceebot_19: 'Are you sure you want to end this conversation?',
  niceebot_20: 'Confirm',
  niceebot_21: 'Cancel',
  official_customer_app_open_failed:
    'Have you installed the Nicee App? If not, you can download it from the app store.',
  official_customer_go_to_store: 'Go to App Store',
  leaderboard: 'Leaderboard',
  leaderboard_1: 'Celebrity List',
  leaderboard_2: 'Newcomer List',
  leaderboard_3: 'Favorite List',
  leaderboard_4: 'Order List',
  leaderboard_5: 'Gift List',
  leaderboard_6: 'Daily List',
  leaderboard_7: 'Weekly List',
  leaderboard_8: 'Rewards and Rules',
  leaderboard_9: 'Charm Value',
  luck_party: 'Lucky Candy Party',
  luck_party_1: 'Draw for a generous diamond coin to get a member gift',
  luck_party_2:
    'Lucky Candy Member Exclusive Party, draw diamond coins to get a lot of member level rewards, waiting for you to get!',
  luck_party_3: 'Activity Time',
  luck_party_4: 'My Candy',
  luck_party_5: 'Wish you good luck',
  luck_party_6: 'Start Drawing',
  luck_party_7: 'Each time consumes 200 candies or consumes 500 diamonds',
  luck_party_8: '10 major member benefits, waiting for you to get',
  luck_party_9: 'VIP1 and above can get member exclusive dress up',
  luck_party_10: 'VIP8 and above can unlock new avatar frames',
  luck_party_11: 'VIP5 and above can receive free coupons',
  luck_party_12: 'VIP10 and above can receive free diamonds',
  luck_party_13: 'VIP9 and above have exclusive mounts',
  luck_party_14:
    'Open special mounts (Dream Sports Car, Extreme Sports Car, Dragon Mount) experience, show noble identity',
  luck_party_15: 'VIP12 and above can enjoy exclusive member gifts',
  luck_party_16:
    'Enjoy exclusive gifts (City in the Sky, Legendary Throne) experience, ignite the enthusiasm of the whole audience',
  luck_party_17: 'View 10 major member benefits',
  palyer_panel_1: 'Income',
  palyer_panel_2: 'Exchange/Gift',
  palyer_panel_3: 'Gift Award 1000 Diamonds',
  palyer_panel_4: 'Skills',
  palyer_panel_5: 'Trends',
  palyer_panel_6: 'Customers',
  palyer_panel_7: 'Recent Visitors',
  palyer_panel_8: 'Self-promotion',
  palyer_panel_10: 'My Orders',
  palyer_panel_11: 'My Gifts',
  palyer_panel_12: 'My Fans',
  palyer_panel_13: 'Comprehensive Score',
  palyer_panel_14: '0 points (higher than 0%)',
  palyer_panel_15: 'My Voice Room',
  palyer_panel_16: 'Invitation',
  palyer_panel_17: 'Customer Service',
  palyer_panel_18: 'Settings',
  palyer_panel_19: 'Income Details',
  palyer_panel_20: 'Available for Withdrawal',
  palyer_panel_21: 'Settlement in Progress',
  palyer_panel_22: 'Total Income',
  palyer_panel_23: 'Income Details',
  palyer_panel_24: 'Income and Expenditure Details',
  palyer_panel_25: 'No records yet',
  line_1: 'LINE Notification Settings',
  line_2:
    'Notify me with LINE when someone leaves a message, has a heart order',
  line_3:
    'Please read the teaching steps below first, then click the open button',
  line_4: 'Click the switch button on the right below',
  line_5:
    'Log in to LINE in the newly opened webpage. If you have installed the LINE app, pull down the webpage to see “Open in LINE”, click to log in quickly.',
  line_6:
    'After logging in successfully, click the first option “Receive LINE Notify notifications through 1-to-1 chat”',
  line_7: 'Click the “Agree and Link” button at the bottom of the page',
  line_8: 'Enable LINE Notification',
  skill_manage_1: 'Currently Available for Orders',
  skill_manage_2: 'Add New Skills',
  skill_manage_3: 'Passed the audit, please complete the skill information',
  skill_cancelled_not_applied: 'Not submitted for certification, edit',
  myclient_1: 'My Customers',
  myclient_2:
    'To help you better manage your customers, we have specially prepared a customer management tool for you, come and take a look!',
  myclient_3: 'Long time no see',
  myclient_4:
    'This place shows customers who have placed orders for you in 7-30 days. Remember to say hello when old friends appear~',
  myclient_5: 'Platform Newcomer',
  myclient_6: 'There are no new users yet, go and maintain old friends',
  recent_visitor_1: 'Recent Visitors',
  recent_visitor_2: 'Visitors in the past 30 days',
  recent_visitor_3: 'How to get more exposure',
  recent_visitor_4: 'First visit',
  mypic_1: 'This Photo Certification',
  mypic_2: 'Super Heartbeat',
  mypic_3: 'Complete identity certification, enjoy 3 privileges',
  mypic_4: 'This Photo Badge',
  mypic_5: 'Get official logo',
  mypic_6: 'Official Recommendation',
  mypic_7: 'Increase exposure',
  mypic_8: 'Order Promotion',
  mypic_9: 'Attract more users',
  service_1: 'Service Overview',
  service_2: 'Comprehensive Score',
  service_3: 'Data for the past 60 days',
  service_4: 'All Skills',
  service_5: 'Order Return Rate',
  service_6: 'Below Standard',
  service_7:
    'Your order return rate is lower than the average level of the platform, you need to work hard~',
  service_8: 'New User Order Number',
  service_9: 'Second Order User Number',
  service_10: 'Per Capita Order Return Amount',
  service_11: 'Order Return Amount',
  service_12: '1 Minute Reply Rate',
  service_13:
    'When you are available for orders, your data for replying within 1 minute is low, which will affect your exposure and order acceptance.',
  service_14: 'Effective Positive Rate',
  service_15:
    'The data of five-star positive reviews with more than 5 words is low, remember to ask users to leave text reviews~',
  service_16: 'Effective Positive Number',
  service_17: 'Total Positive Number',
  myroom: 'My Room',
  who_1: 'Who has seen me',
  who_2: 'Visitors in the past 30 days',
  who_3: 'Chat',
  legal_rules_title: 'nicee Companion Behavior Code',
  legal_privacy_title: 'Terms of Service and Privacy Policy',
  who_4:
    'Companions who join nicee must be fully capable individuals who are at least eighteen years old, have read, understood, and agreed to all the contents of this service agreement and its subsequent modifications and changes, in order to use the services of this platform.\nTo create a healthy platform atmosphere and protect user rights, please companions abide by the following behavior guidelines:\n\nDo not post information that violates laws and regulations in personal information, comments, skill descriptions, and private messages.\nIncluding but not limited to harmful safety, pornography, violence, gambling, harm to minors and other illegal content\n\nDo not post junk advertising information in personal information, comments, skill descriptions, and private messages.\nIncluding but not limited to promoting, selling, profiting as the purpose, publishing content that affects the user experience\n\nDo not post pirated infringement information in personal information, comments, skill descriptions, and private messages.\nIncluding but not limited to unauthorized use of other people’s portraits, names, works content\n\nDo not post false information in personal information, comments, skill descriptions, and private messages.\nIncluding but not limited to fraud, rumors and other false information\n\nDo not post advertising and promotional information in personal information, comments, skill descriptions, and private messages.\nPromote and encourage the use of other competitive platforms, in any form including but not limited to avatars, pictures, nicknames, titles, descriptions, comments and other ways to spread any third-party personal/platform/advertising information/tools not authorized by the nicee platform\n\nDo not trade off the platform\nConduct non-platform order transactions through any other means\n\nDo not harass and insult others\nIncluding but not limited to posting insults, ridicule, personal attacks and other harassment information to platform users\n\nDo not forge interactive data\nIncluding but not limited to artificial or machine cheating to interfere with forged data, maliciously registering multiple accounts for use and other cheating behaviors\n\nDo not harm the interests of the platform and disrupt the order of the platform\nInterfere with platform management in any form, seriously disrupt the order of the platform, and damage the legal rights and interests of other users and the platform\n\nPlatform verification and punishment instructions:\n\nThe platform will confirm violations through user feedback, platform monitoring and other methods.\n\nTo protect user rights, please companions save their own companionship records for verification.\n\nIf users do not comply with the above behavior guidelines, once a violation is found, the platform will take corresponding punishment measures according to the severity of the situation, including warnings, restrictions on the use of some functional rights, account bans, and serious behaviors will freeze the account for a long time.\n\nThe company has the right to modify or change this companion behavior code at any time, and announce it on the website of this platform (https://nicee.tw), please pay attention to such modifications or changes at any time, and no further individual notice will be given. If you continue to use the services of this platform after any modification or change, it is deemed that you have read, understood and agreed to accept such modification or change. And agree to fully comply with this companion behavior code.\n\nWe are committed to creating a safe and healthy service environment for the majority of users. The development of the platform requires your support and cooperation. If you have any suggestions and feedback during use, please contact our customer service assistant, and wish you a happy play in nicee.',
  who_5:
    'This Service Agreement and Privacy Policy (hereinafter referred to as “this Agreement”) stipulates the rights and obligations between you and “nicee”. To protect your (hereinafter referred to as “user”) rights, please read this agreement carefully before registering as a “nicee” (hereinafter referred to as “this platform”) user.\n\nDefinition of Terms (1) “User”: refers to an individual who registers, logs in, and uses any service of this platform. (2) “Service”: refers to the service provided by our company on this platform for users to share, communicate, and play online games through computers, smart devices, or other electronic devices, to match platform users for real-time interaction related to “game coaching”.\n\nRecognition and Acceptance of Terms (1) When you complete registration or start using this service, it means that you have read, understood, and agreed to accept all the contents of this service agreement. If you disagree with the content of this service agreement, or if your country or region excludes all or part of the content of this service agreement, you should not register, log in to this platform’s website, and should immediately stop using the related services of this platform. (2) Our company has the right to modify or change the content of this service agreement at any time and announce it on the website of this platform (https://www.nicee.tw/). Please pay attention to such modifications or changes at any time, and no further individual notice will be given. If you continue to use the services of this platform after any modification or change, it is deemed that you have read, understood, and agreed to accept such modifications or changes. And agree to fully comply with this agreement and other related regulations. If you continue to use the services of this platform after any modification or change, it is deemed that you have read, understood, and agreed to accept such modifications or changes. And agree to fully comply with this agreement and other related regulations. (3) If you are not a person with full capacity for conduct over eighteen years old, you should ask your parents or guardians to read, understand, and agree to all the contents of this service agreement and its subsequent modifications and changes before using the services of this platform. When you use this service, it is presumed that your parents or guardians have read, understood, and agreed to accept all the contents of this service agreement and its subsequent modifications and changes. (4) To promote the healthy development of children and teenagers and protect their related rights and interests, you understand that this platform involves “game software classification management method” classification standard “counseling fifteen-year-old” games, so before choosing to use the corresponding service, you should first understand the game official website The marked game classification logo and applicable age group. Once a specific service is used, it is presumed that you meet the age group requirements for using the game under relevant laws.\n\nUser Registration and Account Custody (1) You agree to provide correct and up-to-date information when registering users (see Article 6 “Privacy Policy”), and can only register and log in to one account, and cannot register and log in repeatedly. If the data you log in changes afterwards, you should update it online at any time. If the personal data you provide is suspected of being false or misleading, our company may terminate your user qualification and stop using various services at any time. (2) You must choose the user’s account name and password to create an account. If your account name is suspected of infringement, our company may request you to change the account name or delete the infringing account directly. (3) You agree that only one person can use an account at the same time, and will not transfer, rent, or lend your own account and password to others. (4) After registration is completed, the user will obtain a specific password and user account, and maintaining the confidentiality and security of the password and account is the user’s responsibility. Whenever the user account and password are entered in accordance with the prescribed method and the login data is consistent, regardless of whether it is entered by the person himself, the platform will be deemed to be used by the user himself, so all actions carried out with this password and account, the user himself should bear full responsibility. (5) If you find that your account is illegally used by others or there is any abnormality that destroys the security of use, please notify our company immediately to stop using the account; but if the account and password are stolen, improperly used, or other situations that cannot be identified whether it is used by the person himself In the case of the damage caused by this, except for the proof that it is due to the cause of our company, our company will not be responsible for the account usage before receiving your notification.\n\nPayment Method and Purchase of nicee Gold Coins (1) You can use the payment method provided by this platform to store “nicee balance” points or purchase other services, but you need to equip all the computer equipment required to browse this platform by yourself, including but not limited to “Internet connection fees”, “telephone fees” and other telecommunications related fees. (2) You clearly understand and agree that if you want to use specific functions in nicee service (such as giving gifts, placing orders for game coaches, etc.), you must first purchase gold coins through the purchase channels approved by nicee. If you violate the above regulations, our company has the right to disable or delete your account, and you will not be able to cancel all your data through your account, including the gold coins and discount coupons in your account. (3) You clearly understand and agree that your purchase of gold coins is a purchase behavior after thinking, except as otherwise provided by law, nicee has no obligation to provide you with any reason for a refund. If you cancel the order after purchasing gold coins through the app mall, we will take back the gold coins you have used, and all kinds of effects accompanying the use of gold coins (including but not limited to benefits, levels, experience points, event display boxes, leaderboards) will also be taken back together. (4) You understand and agree that the gold coins you obtained in the nicee service (such as: holiday activities, leaderboard activities, mutual gifts) cannot be exchanged for cash. And all users are not allowed to conduct private cash transactions, buying and selling or lending accounts. If you violate the above regulations, our company has the right to disable or delete your account. You will not be able to use the service through your account.\n\nUser Code and Platform Use Responsibility (1) User Code: You promise never to use this service for any illegal purpose or in any illegal way, and promise to abide by the relevant laws and regulations of the Republic of China and international conventions. If it is a user outside the Republic of China, and agrees to abide by the laws of their country or region. You agree and guarantee not to use the services of this platform to infringe the rights of others or illegal acts, and abide by the following user code:\n\nDo not publish or transmit any defamatory, insulting, threatening, aggressive, indecent, obscene, false, violating public order or good customs or other illegal text, pictures or any form of file; do not infringe others’ reputation rights, portrait rights, intellectual property rights, Business secrets, etc., for example, sharing content that may reveal personal information or private property without the consent of others, or live broadcasting in private places without permission;\nDo not express “restricted level” content under the “game software classification management method” classification standard to people under the age of eighteen in images, text, images, and sound, including but not limited to “specific sexual hints”, “bloody, brutal or terrifying images”, “Vulgar or hateful language”, “scenes or plots of drug use”, “descriptions of crimes or improper behaviors such as robbery, kidnapping, self-harm, suicide” or “other behaviors or psychological effects that may have adverse effects on people under the age of eighteen” and other content;\nDo not post or transmit any information that infringes the intellectual property rights of others (including but not limited to trademark rights, copyrights, patent rights, trade secrets, etc.), reputation rights, privacy rights or other rights and interests;\nDo not use impersonation, fraud or other false and improper methods to make payments or store values, including but not limited to the situation where the credit card of the payment party is a fake card or is swiped;\nDo not transfer, rent or lend your personal account to others;\nWithout authorization, do not enter the user service system or network of our company, or impersonate the account of others;\nDo not transmit or distribute computer viruses or other data or information that can interfere with or destroy computer systems and applications;\nDo not engage in commercial behavior or transaction behavior without the prior authorization of our company, including but not limited to “false transactions”, “cash out with the platform’s stored value channel or transfer to others”, “exchange the stored value of the platform for non-platform services” and other abnormal use purposes Behavior;\nDo not engage in illegal transactions, or post false, untrue, and criminal messages;\nDo not sell guns, knives, drugs, banned drugs, pirated software or other items prohibited from sale by law;\nDo not cause trouble, displeasure to other users or third parties, or violate general network etiquette to cause disgust\nDo not provide gambling information or publish messages in other ways to induce others to participate in gambling;\nDo not interfere with or interrupt the server providing related services of this platform, connect to the network of this platform, or do not comply with related\nThis Service Agreement and Privacy Policy (hereinafter referred to as “this Agreement”) stipulates the rights and obligations between you and “nicee”. To protect your rights, please read this agreement carefully before registering as a “nicee” user.\n\nDefinition of Terms (1) “User”: refers to an individual who registers, logs in, and uses any service of this platform. (2) “Service”: refers to the service provided by our company on this platform for users to share, communicate, and play online games through computers, smart devices, or other electronic devices, to match platform users for real-time interaction related to “game coaching”.\n\nRecognition and Acceptance of Terms (1) When you complete registration or start using this service, it means that you have read, understood, and agreed to accept all the contents of this service agreement. If you disagree with the content of this service agreement, or if your country or region excludes all or part of the content of this service agreement, you should not register, log in to this platform’s website, and should immediately stop using the related services of this platform. (2) Our company has the right to modify or change the content of this service agreement at any time and announce it on the website of this platform (https://www.nicee.tw/). Please pay attention to such modifications or changes at any time, and no further individual notice will be given. If you continue to use the services of this platform after any modification or change, it is deemed that you have read, understood, and agreed to accept such modifications or changes. And agree to fully comply with this agreement and other related regulations. If you continue to use the services of this platform after any modification or change, it is deemed that you have read, understood, and agreed to accept such modifications or changes. And agree to fully comply with this agreement and other related regulations. (3) If you are not a person with full capacity for conduct over eighteen years old, you should ask your parents or guardians to read, understand, and agree to all the contents of this service agreement and its subsequent modifications and changes before using the services of this platform. When you use this service, it is presumed that your parents or guardians have read, understood, and agreed to accept all the contents of this service agreement and its subsequent modifications and changes. (4) To promote the healthy development of children and teenagers and protect their related rights and interests, you understand that this platform involves “game software classification management method” classification standard “counseling fifteen-year-old” games, so before choosing to use the corresponding service, you should first understand the game official website The marked game classification logo and applicable age group. Once a specific service is used, it is presumed that you meet the age group requirements for using the game under relevant laws.\n\nUser Registration and Account Custody (1) You agree to provide correct and up-to-date information when registering users (see Article 6 “Privacy Policy”), and can only register and log in to one account, and cannot register and log in repeatedly. If the data you log in changes afterwards, you should update it online at any time. If the personal data you provide is suspected of being false or misleading, our company may terminate your user qualification and stop using various services at any time. (2) You must choose the user’s account name and password to create an account. If your account name is suspected of infringement, our company may request you to change the account name or delete the infringing account directly. (3) You agree that only one person can use an account at the same time, and will not transfer, rent, or lend your own account and password to others. (4) After registration is completed, the user will obtain a specific password and user account, and maintaining the confidentiality and security of the password and account is the user’s responsibility. Whenever the user account and password are entered in accordance with the prescribed method and the login data is consistent, regardless of whether it is entered by the person himself, the platform will be deemed to be used by the user himself, so all actions carried out with this password and account, the user himself should bear full responsibility. (5) If you find that your account is illegally used by others or there is any abnormality that destroys the security of use, please notify our company immediately to stop using the account; but if the account and password are stolen, improperly used, or other situations that cannot be identified whether it is used by the person himself In the case of the damage caused by this, except for the proof that it is due to the cause of our company, our company will not be responsible for the account usage before receiving your notification.\n\nPayment Method and Purchase of nicee Gold Coins (1) You can use the payment method provided by this platform to store “nicee balance” points or purchase other services, but you need to equip all the computer equipment required to browse this platform by yourself, including but not limited to “Internet connection fees”, “telephone fees” and other telecommunications related fees. (2) You clearly understand and agree that if you want to use specific functions in nicee service (such as giving gifts, placing orders for game coaches, etc.), you must first purchase gold coins through the purchase channels approved by nicee. If you violate the above regulations, our company has the right to disable or delete your account, and you will not be able to cancel all your data through your account, including the gold coins and discount coupons in your account. (3) You clearly understand and agree that your purchase of gold coins is a purchase behavior after thinking, except as otherwise provided by law, nicee has no obligation to provide you with any reason for a refund. If you cancel the order after purchasing gold coins through the app mall, we will take back the gold coins you have used, and all kinds of effects accompanying the use of gold coins (including but not limited to benefits, levels, experience points, event display boxes, leaderboards) will also be taken back together. (4) You understand and agree that the gold coins you obtained in the nicee service (such as: holiday activities, leaderboard activities, mutual gifts) cannot be exchanged for cash. And all users are not allowed to conduct private cash transactions, buying and selling or lending accounts. If you violate the above regulations, our company has the right to disable or delete your account. You will not be able to use the service through your account.\n\nUser Code and Platform Use Responsibility (1) User Code: You promise never to use this service for any illegal purpose or in any illegal way, and promise to abide by the relevant laws and regulations of the Republic of China and international conventions. If it is a user outside the Republic of China, and agrees to abide by the laws of their country or region. You agree and guarantee not to use the services of this platform to infringe the rights of others or illegal acts, and abide by the following user code:\n\nDo not publish or transmit any defamatory, insulting, threatening, aggressive, indecent, obscene, false, violating public order or good customs or other illegal text, pictures or any form of file; do not infringe others’ reputation rights, portrait rights, intellectual property rights, Business secrets, etc., for example, sharing content that may reveal personal information or private property without the consent of others, or live broadcasting in private places without permission;\nDo not express “restricted level” content under the “game software classification management method” classification standard to people under the age of eighteen in images, text, images, and sound, including but not limited to “specific sexual hints”, “bloody, brutal or terrifying images”, “Vulgar or hateful language”, “scenes or plots of drug use”, “descriptions of crimes or improper behaviors such as robbery, kidnapping, self-harm, suicide” or “other behaviors or psychological effects that may have adverse effects on people under the age of eighteen” and other content;\nDo not post or transmit any information that infringes the intellectual property rights of others (including but not limited to trademark rights, copyrights, patent rights, trade secrets, etc.), reputation rights, privacy rights or other rights and interests;\nDo not use impersonation, fraud or other false and improper methods to make payments or store values, including but not limited to the situation where the credit card of the payment party is a fake card or is swiped;\nDo not transfer, rent or lend your personal account to others;\nWithout authorization, do not enter the user service system or network of our company, or impersonate the account of others;\nDo not transmit or distribute computer viruses or other data or information that can interfere with or destroy computer systems and applications;\nDo not engage in commercial behavior or transaction behavior without the prior authorization of our company, including but not limited to “false transactions”, “cash out with the platform’s stored value channel or transfer to others”, “exchange the stored value of the platform for non-platform services” and other abnormal use purposes Behavior;\nDo not engage in illegal transactions, or post false, untrue, and criminal messages;\nDo not sell guns, knives, drugs, banned drugs, pirated software or other items prohibited from sale by law;\nDo not cause trouble, displeasure to other users or third parties, or violate general network etiquette to cause disgust\nDo not provide gambling information or publish messages in other ways to induce others to participate in gambling;\nDo not interfere with or interrupt the server providing related services of this platform, connect to the network of this platform, or do not comply with related\n',
  language_cn: 'Simplified Chinese',
  language_cn_2: 'Traditional Chinese',
  language_en: 'English',
  language_jap: 'Japanese',
  language_idn: 'Indonesian',
  language_th: 'Thai',
  language_vn: 'Vietnamese',
  first_recharge_bonus: 'First Recharge Bonus',
  new_user_special_offer: 'New User Special Offer',
  pull_down_more: 'Pull down to summon more boosters',
  release_more: 'Release to summon more boosters',
  request_timeout: 'Request timeout',
  voice_room_update_tip:
    'To use the voice chat feature, please upgrade to the latest version',
  voice_room_disabled_in_tip:
    'You have been banned by the administrator and cannot enter',
  push: 'Like',
  coins: 'Coins',
  new_user_coupon_validity: 'New user coupon validity',
  share_to: 'Share to',
  account_belongs_nicee: 'This account belongs to Nicee official',
  fans: 'Fans',
  limited_time1: 'Limited time: 1 coin',
  first_order_info: "Platform's first order, enjoy bronze price",
  new_user: 'New user',
  discount_price: 'off',
  new_user_coupon_discount: 'New user coupon discount',
  hesitant_try_a_7_minute_voice_chat_experience:
    'Hesitant? Try a 7-minute voice chat experience',
  this_user_account_has_been_deleted: 'This user account has been deleted',
  post_a_dynamic: 'Post a dynamic',
  skill_information: 'Skill Information',
  profile_info: 'Profile',
  nickname: 'Nickname',
  copy: 'Copy',
  age: 'Age',
  gift_wall: 'Gift Wall',
  verification_level: 'Verification Level',
  no_ratings_yet: 'No ratings yet',
  user_repurchase: 'User repurchase',
  online_response_time: 'Online response time',
  service_count: 'Service count',
  gift_ranking: 'Gift Ranking',
  connect: 'Connect',
  unblock: 'Unblock',
  she: 'She',
  he: 'He',
  you_have_taken_this_skill_offline_quickly_go_to_skill_management_to_put_it_online:
    'You have taken this skill offline, quickly go to skill management to put it online~',
  this_booster_has_taken_this_skill_offline_quickly_contact_them_to_put_it_online:
    'This booster has taken this skill offline, quickly contact  {msg} to put it online!',
  user_not_found: 'User not found',
  wow_its_so_empty_here: "Wow, it's so empty here",
  no_orders_yet: 'No orders yet',
  no_gifts_received_yet: 'No gifts received yet',
  be_the_first_one_to_place_an_order_for_xxx:
    'Be the first one to place an order for {msg}',
  be_the_first_one_to_send_xxx_a_gift: 'Be the first one to send {msg} a gift',
  file_generation_in_progress: 'File generation in progress',
  come_to_nicee_and_find_xxx_to_play_games:
    'Come to Nicee and find xxx to play games',
  your_understanding_teammates_are_here:
    'Your understanding teammates are here',
  invite_you_to_play: '{msg}Invite you to play{msg2}',
  great_teammates_to_play_games_with_you:
    'nicee,Great teammates to play games with you',
  are_you_sure_you_want_to_unfollow: 'Are you sure you want to unfollow?',
  think_again: 'Think again',
  unfollow: 'Unfollow',
  just_online: 'Just online',
  online: 'Online',
  you_have_blocked_the_other_party_please_unblock_and_try_again:
    'You have blocked the other party, please unblock and try again',
  the_current_version_does_not_support_this_feature_please_update_the_app_version_and_try_again:
    'The current version does not support this feature, please update the app version and try again',
  id_copied_successfully: 'ID copied successfully',
  film: 'film',
  switching: 'Switching...',
  release_to_switch_to_the_gaming_companion_panel:
    'Release to switch to the Gaming Companion Panel',
  release_to_switch_to_the_user_panel: 'Release to switch to the User Panel',
  copied_uuid: 'Copied UUID',
  obtain_limited_avatar_frames_and_cash:
    'Obtain limited avatar frames and cash',
  language_settings: 'Language settings',
  order_records: 'Order records',
  skill_management: 'Skill management',
  my_earnings: 'My earnings',
  'self-promotion_settings': 'Self-promotion settings',
  view_detailed_data: 'View detailed data',
  to_be_improved: 'To be improved',
  good: 'Good',
  excellent: 'Excellent',
  all_data: 'All data',
  explanation_response_rate1:
    'The higher your service quality, the more new users will place repeat orders, increasing your reorder rate~',
  explanation_response_rate3:
    'There is room for improvement in your reorder rate. Please continue to strive for improvement~',
  explanation_response_rate4:
    'Your service performance is good. Keep up the good work!',
  explanation_response_rate5:
    'Your service performance is excellent. Keep up the great work!',
  explanation_response_rate6:
    'No orders received recently. Keep up the good work~',
  explanation_response_rate7:
    'The higher your service quality, the more the reorder users will spend. This will improve your data~',
  explanation_response_rate8:
    'Your data is below the platform average. Keep working hard~',
  explanation_response_rate9:
    'There is room for improvement in your data. Please continue to strive for improvement~',
  explanation_response_rate10:
    'Your service performance is good. Keep up the good work!!',
  explanation_response_rate11:
    'Your service performance is excellent. Keep up the great work!',
  explanation_response_rate12: 'No recent reorders~',
  explanation_response_rate13:
    'Responding actively to user messages within 1 minute can effectively improve this indicator~',
  explanation_response_rate14:
    'While in the order-receivable state, your response rate within 1 minute is low, which will affect your exposure and order acceptance.',
  explanation_response_rate15:
    'While in the order-receivable state, your response rate is timely. Keep up the good work!',
  explanation_response_rate16:
    'While in the order-receivable state, your response rate is very timely. Keep up the great work!',
  explanation_response_rate17: 'No recent conversations initiated or received~',
  explanation_response_rate18:
    'Receiving five-star ratings with comments of more than 5 words can quickly improve your effective positive rating~',
  explanation_response_rate19:
    'Users frequently leave positive comments for you. Keep up the good work!',
  explanation_response_rate20:
    'Your service receives overwhelming positive feedback. Keep up the great work!',
  explanation_response_rate21: 'No ratings received recently~',
  explanation_response_rate22:
    'Due to your failure to respond to user messages or accept orders in a timely manner, your order-receivable status has been deactivated by the system. It cannot be reopened within 5 minutes. Please wait and try again later.',
  current_value: 'Current value',
  current_index: 'Current index',
  certificate_of_this_photo1:
    "Please note that this photo verification only verifies whether the user's photo is of a real person. There is still a possibility that the profile picture does not match the user.",
  certificate_of_this_photo2:
    'Photos are only for use on the nicee social platform and cannot be used for other purposes.',
  certificate_of_this_photo3:
    'Changing the profile picture will invalidate the verification and the user will need to re-verify.',
  certificate_of_this_photo4:
    'Verification can be done up to 3 times per week, and the count resets every Monday.',
  certificate_of_this_photo5: 'You have passed the photo verification.',
  certificate_of_this_photo6: 'Enjoying privileges',
  certificate_of_this_photo7: 'Passed photo verification',
  certificate_of_this_photo8:
    "The profile picture has been confirmed to be the user's own.",
  verify_now: 'Verify now',
  under_review: 'Under review',
  certificate_of_this_photo9:
    'The verification result will be announced within 10 minutes.',
  failed_photo_verification: 'Failed photo verification',
  certificate_of_this_photo10:
    'The maximum number of verifications for this week has been reached. You can apply for verification again next Monday.',
  photo_verification_rules: 'Photo verification rules',
  rules_for_accepting_orders1: 'Current order-receiving rules and explanations',
  rules_for_accepting_orders2:
    'Enabling this button indicates that you are currently available to accept orders.',
  rules_for_accepting_orders3:
    'If you enable the "Current Order-Receivable" button, it means you can currently accept orders. The system will automatically deactivate your order-receivable status if you engage in the following behaviors:',
  rules_for_accepting_orders4:
    'If a user sends you a message for the first time on the same day and you do not respond to the message promptly within 1 minute.',
  rules_for_accepting_orders5:
    'Reminder: If you encounter users who violate the rules, please directly block or report them. Blocking a user will not affect your online status for the current message~',
  rules_for_accepting_orders6: 'Not accepting orders for more than 10 minutes',
  rules_for_accepting_orders7:
    'Reminder: Making users wait for too long is not a good online gaming experience~',
  rules_for_accepting_orders8:
    'Please note: If your order-receivable status is deactivated by the system, there will be a period of time when you cannot open the order-receivable status. Please handle it carefully~',
  skill_add1: 'Not yet added common skills.',
  skill_add2: 'Go and add.',
  skill_add3: 'Add up to 30 common categories.',
  skill_add4: 'Added as a common skill.',
  skill_add5: 'Computer games.',
  skill_add6: 'Console games.',
  skill_add7: 'Voice companionship.',
  skill_add8: 'More skills.',
  home_ranking1:
    '·Ranked based on the accumulated order amount of the boosting specialist for the day.',
  home_ranking2: '·Reset at 0:00:00 daily.',
  home_ranking3: '·Leaderboard data updated at 0:05:00 daily.',
  home_ranking4: '·Exclusive title for 1 day.',
  home_ranking5:
    '·Ranked based on the accumulated order amount of the boosting specialist for the week.',
  home_ranking6: '·Reset at 0:00:00 on Sunday.',
  home_ranking7:
    '·Leaderboard data displayed/updated until 23:59:59 on Monday.',
  home_ranking8: '·Exclusive title for 1 week.',
  home_ranking9:
    "·Single skill list pinned for 1 day. Customer service will inquire about the boosting specialist's intention to be pinned every Tuesday.",
  home_ranking10:
    '·Ranked based on the accumulated order amount of the newcomer boosting specialist for the day.',
  home_ranking11:
    '·Newcomer boosting specialist defined as: a boosting specialist who joined within the last 30 days as of 0:00:00 of the current day.',
  home_ranking12:
    '·Ranked based on the accumulated order amount of the newcomer boosting specialist for the week.',
  home_ranking13:
    '·Newcomer boosting specialist defined as: a boosting specialist who joined within the last 30 days as of 0:00:00 on Monday of the current week.',
  home_ranking14: '·Single skill list pinned for 2 hours, 3 days.',
  home_ranking15:
    '·Ranked based on the accumulated gifting amount to the boosting specialist for the day.',
  home_ranking16:
    '·Ranked based on the accumulated gifting amount to the boosting specialist for the week.',
  home_ranking17:
    '·According to the accumulated confirmed order total amount of platform users on that day, ranking can be determined.',
  home_ranking18:
    '·Ranked based on the accumulated total order amount confirmed by platform users for the week.',
  home_ranking19: '·Exclusive profile frame for 1 week.',
  home_ranking20:
    '·Ranked based on the accumulated gifting order amount by platform users for the day.',
  home_ranking21:
    '·Ranked based on the accumulated gifting order amount by platform users for the week.',
  home_ranking22: '·Exclusive chat bubble for 1 week.',
  no_one_here_at_the_moment: 'No one here at the moment~',
  ranking_list_submit: 'Submit.',
  contribution_points: 'Contribution points.',
  data_updated_every_monday_night_at_2400:
    'Data updated every Monday night at 24:00.',
  ranking_list_my: 'My',
  congratulations_you_are_currently_ranked_first:
    'Congratulations, you are currently ranked first.',
  no_gifts_sent_yet: 'No gifts sent yet.',
  still_need_msg_to_catch_up_with_the_previous_rank:
    'Still need {msg} to catch up with the previous rank.',
  send_a_gift: 'Send a gift.',
  overall_leaderboard: 'Overall leaderboard.',
  network_anomaly: 'Network anomaly.',
  please_enter_a_nickname_ID_game_skill:
    'Please enter a nickname/ID/game skill.',
  clear_search_history: 'Clear search history.',
  related_skills: 'Related skills.',
  freelance_skills_marketplace: 'Freelance skills marketplace.',
  related_users: 'Related users.',
  sorry_no_content_related_to_msg_found:
    'Sorry, no content related to {msg} found.',
  pull_down_to_summon_more_updates: 'Pull down to summon more updates...',
  release_to_summon_more_updates: 'Release to summon more updates...',
  dynamic_deleted_successfully: 'Dynamic deleted successfully.',
  coins_game: 'coins/game.',
  people_like_this: 'people like this.',
  reply_msg: 'Reply: {msg}',
  write_a_message: 'Write a message...',
  maximum_200_characters_allowed: 'Maximum 200 characters allowed!',
  reply: 'Reply.',
  delete: 'Delete.',
  expand_reply: 'Expand reply.',
  collapse_reply: 'Collapse reply.',
  wow_its_empty_here: "Wow~ It's empty here.",
  follow_a_boosting_specialist_to_see_their_updates:
    'Follow a boosting specialist to see their updates!',
  express_matchmaking: 'Express matchmaking.',
  find_boss: 'Find boss.',
  cancel_order: 'Cancel Order',
  what_is_the_reason_for_canceling_your_order:
    'What is the reason for canceling your order?',
  canceling_multiple_times_will_affect_future_orders:
    'Canceling multiple times will affect future orders.',
  please_enter_the_reason: 'Please enter the reason...',
  experimental_operation: 'Experimental operation',
  too_few_available_game_coaches: 'Too few available game coaches',
  unable_to_find_a_satisfactory_game_coach:
    'Unable to find a satisfactory game coach',
  incorrect_order_details: 'Incorrect order details',
  other_reasons: 'Other reasons',
  this_order_has_been_canceled: 'This order has been canceled',
  completed_tutorial: 'Completed tutorial',
  order_completed: 'Order completed',
  order_conditions: 'Order conditions',
  successfully_matched_with_a_game_coach:
    'Successfully matched with a game coach',
  a_total_of: 'a total of',
  game_coaches_are_available_for_order: 'game coaches are available for order',
  accepted_msg_times: 'Accepted {msg} times',
  msg_repurchase_rate: '{msg}% repurchase rate',
  express_tutorial: 'Express tutorial',
  place_an_order: 'Place an order',
  notification_settings: 'Notification settings',
  only_retain_the_latest_10_order_records:
    'Only retain the latest 10 order records',
  you_already_have_an_ongoing_order: 'You already have an ongoing order',
  guaranteed_rank_boost: 'Guaranteed Rank Boost',
  experience_order: 'Experience order',
  'one-click_order': 'One-click order',
  'text-based_order': 'Text-based order',
  'voice-based_order_only': 'Voice-based order only',
  'voice-based_order': 'Voice-based order',
  'one-click_order_use_voice_commands_to_place_an_order':
    'One-click order: Use voice commands to place an order.',
  already_claimed: 'Already claimed',
  game_coaches_are_claiming_orders: 'game coaches are claiming orders',
  providing_detailed_introductions_increases_the_chances_of_getting_orders:
    'Providing detailed introductions increases the chances of getting orders',
  order_card_info1:
    'For example: "Hello, I can speak multiple languages. My best role is support, and I can be your dedicated support."(5-25 words)',
  order_card_info2:
    'Note: Strictly prohibit inappropriate behavior, severe penalties for violators',
  confirm_order_claim: 'Confirm order claim',
  no_restrictions: 'No restrictions',
  today: 'Today',
  msg_month_msg2_day: '{msg}th month, {msg}th day',
  explanation_of_guaranteed_ein_order: 'Explanation of "Guaranteed Win" order',
  order_card_info3:
    '1.Game coaches need to have an account with the corresponding rank to accept the order.\\n\\n2.Guaranteed win orders are priced based on the number of victories, and the price can be customized based on the rank. Please provide a quote when claiming the order.\\n\\n3.By clicking "Agree," the game coach agrees to reach a consensus with the user and obtains the net number of victories through mutual negotiation.',
  agree: 'Agree',
  order_card_info4:
    'Your League of Legends certification level does not meet the requirements. Please improve your level before claiming orders.',
  an_error_occurred_please_refresh_the_page_and_try_again:
    'An error occurred. Please refresh the page and try again.',
  the_order_claim_mode_is_not_suitable: 'The order claim mode is not suitable',
  order_card_info5:
    'The price for the "{msg}" mode is not set. Please set it before claiming orders.',
  go_to_settings: 'Go to settings',
  no_mode_restrictions: 'No mode restrictions',
  the_order_pricing_unit_does_not_meet_the_requirements:
    'The order pricing unit does not meet the requirements',
  order_card_info6:
    'The price for the "{msg}" pricing unit is not set. Please set it before claiming orders.',
  your_price_exceeds_the_order_requirements:
    'Your price exceeds the order requirements',
  order_card_info7:
    'Your price is too high. Would you like to lower the price for this order? We can lower the price to ${msg} without affecting your normal order price.',
  lower_price_and_claim_order: 'Lower price and claim order',
  cancel_order_claim: 'Cancel order claim',
  order_card_info8:
    'Set the wake-up time to {msg}. Confirm if you agree to claim the order?',
  confirm: 'Confirm',
  if_you_reach_the_elite_rank: 'If you reach the Elite rank.',
  if_you_reach_the_eternal_legend_rank: 'If you reach the Eternal Legend rank.',
  order_card_info9:
    'Currently, the guaranteed win order is by invitation only. {msg}, please prepare the relevant proof and contact customer service assistant for application.',
  order_card_info10:
    'Your rank hasn\'t reached "Elite" / "Eternal Legend," please certify before accepting orders.',
  order_card_info11:
    'Too much repetitive text. Adding rich text descriptions can increase the chances of being selected.',
  order_card_info12:
    'Congratulations on joining the order queue! Comprehensive rating UP!!',
  i_want_to_schedule_an_order: 'I want to schedule an order.',
  'limited-time_offer_for_first-time_customers':
    'Limited-time offer for first-time customers!',
  remaining: 'Remaining',
  what_kind_of_msg_are_you_looking_for:
    'What kind of {msg} are you looking for?',
  coach: 'coach',
  order_scheduling_available_from: 'Order scheduling available from',
  early_morning: 'Early morning',
  looking_for_coaching: 'Looking for coaching.',
  please_select_your_coaching_requirements:
    'Please select your coaching requirements.',
  please_select_coaching_mode: 'Please select coaching mode.',
  mode: 'Mode',
  your_rank: 'Your rank',
  rank: 'Rank',
  please_select_your_current_rank: 'Please select your current rank.',
  time: 'Time',
  select_time: 'Select time',
  select_msg: 'Select {msg}',
  voice_recording_is_required_when_securing_an_order:
    'Voice recording is required when securing an order.',
  order_card_info13:
    'You can enter your customized requirements. Posting explicit, abusive, or advertising content will result in a ban.',
  please_confirm_your_order_requirements:
    'Please confirm your order requirements.',
  confirm_order: 'Confirm Order',
  order_card_info14:
    'Time for selection is 15 minutes. If it exceeds the time limit, a compensation of $5 to $10 may be deducted for the booster.',
  days: 'Days',
  coaching_tier: 'Coaching tier',
  price: 'Price',
  mode_unlimited: 'Mode: Unlimited',
  rank_no_restriction: 'Rank: No restriction',
  order_card_info15:
    'To ensure a smooth ordering experience, please make sure your account balance is sufficient before scheduling an order. Current balance:',
  insufficient_balance: 'Insufficient balance',
  got_it: 'Got it',
  please_select_the_number_of_orders: 'Please select the number of orders.',
  order_card_info16:
    'The server is misbehaving. The engineers are working hard to tame it.',
  please_select_your_rank: 'Please select your rank.',
  elite: 'Elite',
  order_card_info17:
    '1."Guaranteed Win" orders will be sent to all platform coaches "{msg}"\\n\\n2. Prices are calculated based on wins and vary depending on the rank. Please negotiate with the booster for the specific price.\\n\\n3. Gender selection for the booster is currently not supported.',
  guaranteed_win_order_explanation: 'Guaranteed Win Order Explanation',
  insufficient_account_balance: 'Insufficient account balance',
  i_want_to_recharge: 'I want to recharge.',
  current_balance: 'Current balance',
  order_notification_settings: 'Order notification settings',
  order_notification: 'Order notification',
  select_coach: 'Select coach',
  select_booster: 'Select booster',
  countdown: 'Countdown',
  my_orders: 'My orders',
  order_requirements: 'Order requirements',
  the_booster_is_on_the_way_please_wait:
    'The booster is on the way. Please wait...',
  the_booster_is_on_the_way: 'The booster is on the way...',
  boosters_have_replied_please_select_your_preferred_booster:
    'boosters have replied. Please select your preferred booster.',
  boosters_have_taken_orders_waiting_for_selection:
    'boosters have taken orders. Waiting for selection.',
  boosters_are_waiting_for_your_response_whom_would_you_like_to_choose:
    'boosters are waiting for your response. Whom would you like to choose?',
  see_more: 'See more',
  randomly_select_one: 'Randomly select one',
  the_maximum_number_of_boosters_available_for_order_has_been_reached_msg:
    'The maximum number of boosters available for order has been reached ({msg}).',
  more_boosters_are_on_their_way: 'More boosters are on their way...',
  no_more_available: 'No more available',
  buy_msg_get_msg_for_free: 'Buy {msg}, get {msg} for free',
  apply_for_coaching: 'Apply for coaching',
  waiting_order_tip1:
    'Your order has been automatically canceled due to timeout.',
  waiting_order_tip2:
    "The number of daily cancellations has exceeded the limit, so you won't be able to request an express order again today.",
  waiting_order_tip3: 'The order has ended.',
  waiting_order_tip4:
    'This order has been automatically canceled due to timeout.',
  waiting_order_tip5: 'You have 30 seconds left, please choose quickly',
  hint: 'hint',
  comment: 'comment',
  price_range_minutes7: 'Price must be between 30-40',
  price_range_limit: 'Price must be between {priceLeft}-{priceRight}',
  price_range_invalid: 'Please enter a valid price',
  custom_price: 'Custom price',
  custom_price_placeholder: 'Enter price',
  new_user_auto_greeting: 'Auto greet new users',
  new_user_auto_greeting_tip:
    'After a new user registers, Nicee will use this message to start a 1v1 chat.',
  new_user_auto_greeting_voice: 'Voice message',
  new_user_auto_greeting_limit:
    'Eligible hosts need score 1000+, online, and available for orders.',
  enable_new_user_auto_greeting: 'Enable auto greet',
  new_user_auto_greeting_empty: 'Please add text or a voice message.',
  save: 'Save',
  modify: 'Edit',
  first_order_discount: 'First order discount',
  evaluate: 'Evaluate',
  user_not_exist: 'User does not exist',
  dislike: 'Dislike',
  rating_success: 'Rating submitted',
  save_successfully: 'Saved successfully',
  h5_live_setting_title: 'Live Settings',
  h5_live_detection: 'Live Detection',
  h5_live_detection_tip:
    'During live streaming, the live view will appear in your profile updates',
  h5_live_title: 'Live Title',
  h5_live_title_placeholder: 'Tap to enter a live title',
  h5_live_url: 'Live Link',
  h5_live_url_placeholder: 'Tap to enter a live link',
  h5_live_supported_platform: 'Supported Platforms',
  h5_live_cover: 'Live Cover',
  h5_live_cover_tip: 'Upload again to update the cover',
  h5_live_url_required: 'Link cannot be empty',
  h5_live_url_invalid: 'Invalid link',
  h5_live_title_required: 'Title cannot be empty',
  h5_live_cover_required: 'Cover cannot be empty',
  h5_order_comment_feeling_title:
    'How do you feel about this user?',
  h5_order_comment_anonymous_done: 'Anonymous',
  h5_order_comment_choose_reason:
    'Please choose a reason to help the platform maintain a healthy community',
  h5_order_comment_feedback_placeholder:
    'Your feedback helps us improve (up to 200 characters)',
  h5_order_comment_privacy_tip:
    'Ratings will not be shown to other users and are only used for data collection',
  h5_order_comment_submit: 'Submit rating',
  h5_order_comment_exit_message:
    'Leaving will discard this rating. Are you sure?',
  h5_order_comment_confirm_exit: 'Confirm exit',
  h5_month_day: '{month}/{day}',
  h5_gift_total_count: 'Total gifts',
  h5_gift_wall_empty: 'No gifts received yet. Keep going!',
  h5_yomi_empty: 'No games available',
  h5_bind_invitation_code: 'Bind invitation code',
  h5_player_list_default_title: 'Squad Zone',
  h5_new_user_coupon: 'New user coupon',
  h5_fans_count: 'Fans',
  h5_full_discount_offer: 'Buy {startNum}, get {giftNum} free',
  h5_recharge_before_send_gift:
    'Please top up on the recharge page before sending a gift',
  h5_selected_gift_not_exist: 'The gift you selected does not exist',
  h5_gift_rejected: 'Your gift was rejected',
  h5_balance_not_enough_recharge_first:
    'Your balance is insufficient. Please top up first',
  h5_gift_send_failed: 'Failed to send gift',
  h5_gift_count_1: 'Wholehearted',
  h5_gift_count_10: 'Perfect',
  h5_gift_count_99: 'Forever',
  h5_gift_count_188: 'Need a hug',
  h5_gift_count_520: 'I love you',
  h5_gift_count_1314: 'For a lifetime',
  h5_gift_snowman_not_enough:
    'You do not have enough Warm Snowmen. Go to the event page to buy more?',
  h5_gift_bell_need_buy:
    'You still need to buy {count} Christmas Bell(s). Continue?',
  h5_gift_deprecated: 'Unavailable',
  h5_player_detail_chat_before_order_title: 'Chat before ordering',
  h5_player_detail_chat_before_order_text:
    'Chatting before ordering helps confirm companion details',
  h5_player_detail_order_direct: 'Order directly',
  h5_player_detail_go_chat: 'Go chat',
  h5_player_detail_no_remind: 'Do not remind me again',
  h5_player_detail_tag_explain: 'Tag explanation',
  h5_player_detail_tag_rebought: 'Repeat-order star',
  h5_player_detail_tag_rebought_desc:
    'Top 20 average repeat orders per person (last 90 days)',
  h5_player_detail_tag_nice: 'Great reputation',
  h5_player_detail_tag_nice_desc: 'Selected for homepage review recommendations',
  h5_player_detail_tag_hot: 'Popular',
  h5_player_detail_tag_hot_desc: 'Receives many orders',
  h5_player_detail_tag_new: 'Quality newcomer',
  h5_player_detail_tag_new_desc:
    'A quality companion who joined recently',
  h5_player_detail_tag_position: 'Position verified',
  h5_player_detail_tag_position_desc: 'Performs well in this position',
  h5_guardian_gift_reach: 'Send gifts reaching',
  h5_guardian_can_be_guardian: 'to become a guardian',
  h5_guardian_need_more_to_be_guardian:
    'You still need {count}💎 to become a guardian',
  h5_list_separator: ', ',
  h5_player_detail_comment_player_reply: 'Companion reply',
  h5_player_detail_comment_empty_self:
    'No one has reviewed you yet',
  h5_player_detail_comment_empty_other:
    'No one has reviewed this companion yet',
  h5_player_detail_comment_reply_placeholder: 'Write a reply...',
  h5_player_detail_comment_reply_confirm:
    'You only have one chance to reply to a review. It cannot be changed after submission.',
  h5_player_detail_comment_hidden_default:
    '-{count} default positive review(s) hidden-',
  h5_gift_icon_title: 'What is a gift medal?',
  h5_gift_icon_desc1:
    'A gift medal is earned by users on nicee by sending gifts',
  h5_gift_icon_desc2:
    'The medal appears after nicknames in comments, voice room public chat, and profile cards',
  h5_gift_icon_rule_title: 'Rules:',
  h5_gift_icon_rule_time: '- Gift medals are calculated and issued daily at 06:00',
  h5_gift_icon_level1_line1:
    'Gift amount on the platform in the last 30 days is at least NTD 500, ',
  h5_gift_icon_level1_line2: 'and less than NTD 1000 to receive it',
  h5_gift_icon_level2_line1:
    'Gift amount on the platform in the last 30 days is at least NTD 1000, ',
  h5_gift_icon_level2_line2: 'and less than NTD 2500 to receive it',
  h5_gift_icon_level3_line1:
    'Gift amount on the platform in the last 30 days is at least NTD 2500',
  h5_gift_icon_level3_line2: 'to receive it',
  h5_limited_time: 'Limited',
  h5_player_list_super_cheap: 'Super cheap',
  h5_player_list_newbie: 'Newbie',
  h5_refund_no_reply_auto_refund:
    'If the companion does not reply within 24 hours, the refund will take effect automatically and the amount will return to your account',
  h5_refund_negotiate_tip:
    'If you disagree with the amount, you can continue communicating with the companion and ask them to refund you. If no agreement is reached, you can ask customer service to intervene. If no action is taken, the order will be completed automatically after 7 days.',
  h5_refund_reason_completed: 'Service completed',
  h5_refund_reason_malicious: 'Malicious refund request by user',
  h5_request_error: 'Request failed!',
  h5_minutes_ago: '{msg} minutes ago',
  h5_hours_ago: '{msg} hours ago',
  h5_days_ago: '{msg} days ago',
  h5_relegation_privilege_title:
    'What is Level Protection Privilege and how do you get it?',
  h5_relegation_privilege_desc:
    'When claiming level rewards, using Level Protection Privilege will not deduct any level points. If you reach Legend level 3 times in a row (VIP13 or above) without using the privilege, you can gain 1 additional privilege. Up to 2 privileges can be accumulated.',
  h5_relegation_privilege_current:
    'Level Protection Privileges you currently have: {count}',
  h5_relegation_privilege_continuous:
    'Current consecutive Legend count: {count}',
  h5_relegation_privilege_max:
    'Privilege count has reached the maximum limit',
  h5_relegation_privilege_note:
    'Note: After using Level Protection Privilege, the consecutive Legend count will be reset.',
  h5_relegation_privilege_example1:
    'If your level reaches VIP13 or above on the 1st day settlement for 3 consecutive months: ',
  h5_relegation_privilege_example2:
    'On the 1st day of months 1 and 2, the consecutive Legend count will show 1 and 2 respectively; ',
  h5_relegation_privilege_example3:
    'In month 3, the consecutive count will show 0 and Level Protection Privilege will increase by 1. ',
  h5_relegation_privilege_example4:
    'But if you use Level Protection Privilege during month 2, the consecutive Legend count will immediately change from 2 to 0, and remain 0 on the 1st day of month 3.',
  all: 'All',
  other: 'Other',
  new_to_the_platform: 'New to the platform',
  h5_customer_long_time_no_see: 'Long time no see',
  h5_customer_old_tip:
    '{total} people have not ordered from you for a long time. Say hello to them',
  h5_customer_interaction_history: 'Interaction history',
  h5_customer_chat_with: 'Chat with {pronoun}',
  h5_customer_new_done:
    'All new users needing follow-up have been handled',
  h5_customer_old_empty:
    'Customers who ordered from you in the past 7-30 days are shown here. Remember to greet old friends when they appear.',
  h5_customer_greeting_1: 'Hello~ Invite me if you want to play!',
  h5_customer_greeting_2: 'Hi boss~ Want to play games?',
  h5_customer_greeting_3: 'You are here~ I have been waiting > <',
  h5_customer_edit_message: 'Edit content to send',
  h5_customer_custom: 'Custom',
  h5_customer_send: 'Send',
  h5_customer_send_success: 'Sent successfully',
  h5_customer_input_placeholder: 'Tap to enter...',
  h5_customer_group_send: 'Mass send',
  h5_customer_once_per_day: 'One chance per day',
  h5_customer_order_summary_prefix: 'Ordered ',
  h5_customer_order_summary_middle: ' times, total value ',
  h5_customer_order_summary_suffix: ' coins,',
  h5_customer_order_history: 'Order history',
  h5_customer_order_history_item_prefix:
    '{pronoun} ordered ',
  h5_customer_order_history_item_middle:
    ' from you {count} times, order amount ',
  h5_player_topic_recommend_reason: 'Recommendation reason: ',
  h5_income_withdraw: 'Withdraw',
  h5_income_order_no: 'Order: {orderNo}',
  h5_income_balance: 'Balance: {amount}',
  h5_income_repurchase_subsidy: 'Including repeat purchase subsidy +{amount}',
  h5_income_order_no_copied: 'Order number copied',
  h5_income_revenue: 'Income',
  h5_income_expense: 'Expense',
  h5_income_select_year_month: 'Select year and month',
  h5_income_all_time: 'All time',
  h5_income_year_month: '{year}/{month}',
  h5_income_settlement_note:
    'Normal order settlement will be completed within 7 business days',
  h5_diamond_start_exchange: 'Start exchange',
  h5_vip_member_outfit_permanent: 'Member exclusive outfit (permanent)',
  h5_vip_member_outfit_remark:
    'Level exclusive avatar frame, chat bubble, and entry banner',
  h5_vip_coupon_title: '{count} {amount}-coin discount coupon(s)',
  h5_vip_monthly_claim_all:
    'Available after the 1st of each month (sitewide)',
  h5_vip_need_points: 'Requires {points} member points',
  h5_vip_diamond_title: '{amount} diamonds',
  h5_vip_monthly_claim: 'Available after the 1st of each month',
  h5_vip_avatar_frame: '"{name}" avatar frame (permanent)',
  h5_vip_mount: '"{name}" mount',
  h5_vip_mount_permanent: '"{name}" mount (permanent)',
  h5_vip_voice_room_enter: 'Shown as identity when entering voice rooms',
  h5_vip_voice_room_noble_enter:
    'Shown as noble identity when entering voice rooms',
  h5_vip_unlock_level_gift: 'Unlock level exclusive gift "{name}"',
  h5_vip_level_gift: 'Level exclusive gift "{name}"',
  h5_vip_home_recommend_hours:
    'Gift recipient gets homepage recommendation for {hours} hours',
  h5_vip_app_cover_hours: 'Gift recipient appears on APP cover for {hours} hours',
  h5_vip_exclusive_frame: 'Exclusive avatar frame "{name}" (permanent)',
  h5_vip_gift_both_get:
    'After sending "{name}", both sender and recipient can receive it',
  h5_vip_beautiful_id: '{digits}-digit special ID',
  h5_vip_permanent_custom_frame:
    '1 permanent exclusive avatar frame of your choice',
  h5_vip_item_qili_fire: 'Brilliant Fireworks',
  h5_vip_item_bright_stars: 'Shining Stars',
  h5_vip_item_dream_car: 'Dream Sports Car',
  h5_vip_item_white_tiger: 'White Tiger',
  h5_vip_item_extreme_car: 'Extreme Sports Car',
  h5_vip_item_romantic_firework: 'Romantic Fireworks',
  h5_vip_item_qilin: 'Qilin',
  h5_vip_item_moved_for_you: 'Moved for You',
  h5_vip_item_crystal_shine: 'Crystal Shine',
  h5_vip_item_pyramid: 'Pyramid',
  h5_vip_item_legend: 'Legend',
  h5_vip_item_phoenix: 'Phoenix',
  h5_vip_item_sky_city: 'Castle in the Sky',
  h5_vip_item_legend_phoenix: 'Legend Phoenix',
  h5_vip_item_king_legend: 'King Legend',
  h5_vip_item_dragon: 'Dragon',
  h5_vip_item_legend_throne: 'Legend Throne',
  h5_vip_item_legend_dragon: 'Legend Dragon',
  h5_vip_item_eternal_legend: 'Eternal Legend',
  h5_vip_item_manifest_world: 'World Manifest',
  h5_vip_item_nirvana: 'Nirvana',
  speak_now_rank_rule: 'Ranked by gift points from the last three days. Gifts sent in chat rooms earn 5x points.', speak_now_confess: 'Confess now', speak_now_select_target: 'Choose who you want to confess to', speak_now_search_placeholder: 'Enter nickname or ID', speak_now_visit_profile: 'View profile', speak_now_recent_gifters: 'People you recently sent gifts to', speak_now_create_title: 'Who do you want to share your feelings with?', speak_now_select_confession_target: 'Choose a confession target', speak_now_content_placeholder: 'Enter your confession', speak_now_score: 'Affection score: {score}', speak_now_score_too_low: 'Affection score too low?', speak_now_send_more_gifts: 'Send more gifts', speak_now_select_target_error: 'Please choose a confession target.', speak_now_content_error: 'Please enter your confession.', speak_now_success: 'Confession sent!',
  newcomer_zone_title: 'Newcomers', newcomer_zone_subtitle: 'Meet our newest companions', newcomer_zone_latest: 'Latest posts', coupon_invitation_title: 'Enter invitation code', coupon_invitation_placeholder: 'Enter invitation code', coupon_invitation_invalid: 'The invitation code is incorrect. Please check and try again.', coupon_phone_invalid: 'The phone number is missing or is not a Taiwan number.', coupon_bind_failed: 'Binding failed',
  apullc_hero: 'Refer friends and earn 3% of their top-ups', apullc_reward_summary_1: 'Earn 3% top-up rewards and an exclusive avatar frame', apullc_reward_summary_2: 'Friends receive a free trial coupon and 100 coins in coupons', apullc_detailed_rules: 'Detailed rules', apullc_rules: 'When a friend registers with your invitation code, you receive 3% of each top-up they make within 60 days (calculated up to 30,000 per top-up). Invite 15 friends to receive a permanent exclusive avatar frame. New friends receive a 50-coin coupon and a coupon pack worth 100 coins.', apullc_link_copied: 'Invitation link copied', apullc_share_link: 'Or share your invitation link', apullc_my_records: 'My activity records', apullc_total_invited: 'Total invited users', apullc_cashback_total: 'Total top-up cashback', apullc_points_total: 'Total member points', apullc_limited_frame: 'Exclusive avatar frame', apullc_frame_name: 'Cyber Rebel', obtained: 'Obtained', apullc_recent_rewards: 'Recent rewards', apullc_no_records: 'No records yet. Invite your friends now!', apullc_bind_code: 'Bind invitation code', claim: 'Claim', apullc_notes: 'Invitation rewards may take time to process. Only accounts bound to a Taiwan phone number count as valid invited users. Duplicate registrations are invalid. Contact customer service if you have questions.', apullc_share_message: 'Join me on Nicee and find great gaming companions! Register through my invitation link to receive a free order and coupon pack.', apullc_clipboard_denied: 'Clipboard permission denied', apullc_got_frame: 'Received the Cyber Rebel avatar frame', apullc_recharge_reward: '{user} topped up and earned {amount} coins',
  apullc_claim_offer_title: 'Claim your exclusive offer!', apullc_kol_offer: 'One free order and a coupon pack worth 250 coins', apullc_standard_offer: 'One free order and a coupon pack worth 100 coins', apullc_bind_phone: 'Please bind your phone number', phone_number: 'Phone number', sending: 'Sending', apullc_resend_countdown: 'Resend ({seconds})', apullc_get_code: 'Get verification code', verification_code: 'Verification code', invitation_code: 'Invitation code', claim_offer: 'Claim offer', nicee_platform_tagline: 'A quality gaming companion platform', enter_phone_number: 'Please enter your phone number', phone_number_format_error: 'Invalid phone number format', enter_valid_phone_number: 'Please enter a valid phone number', enter_invitation_code: 'Please enter the invitation code', verification_code_error: 'Incorrect verification code', apullc_success_reward: 'Congratulations! You received your referral reward.', apullc_success_login: 'Sign in to Nicee with your phone number to use the offer.', apullc_google_play_opened: 'Opening Google Play', apullc_google_play_fallback: 'Google Play is unavailable. The APK will be downloaded directly.',
  view_full_image: 'View full image', updating: 'Updating', retry: 'Retry', generating: 'Generating...', loading: 'Loading', vocality_voice_intro: 'Voice introduction', vocality_record_sample: 'Record a voice sample', vocality_recommended_duration: 'Recommended: 7–10 seconds', vocality_record_description: 'Record a clear 7–10 second voice sample to create your voice profile card.', vocality_recording_tips: 'Recording tips', vocality_tip_duration: 'Recommended length: 7–10 seconds', vocality_tip_clarity: 'Speak clearly at a moderate pace', vocality_tip_noise: 'Avoid background noise', vocality_card_preview: 'Voice profile card preview', vocality_generating_official: 'Generating your official voice profile card...', vocality_loading_existing: 'Loading your existing voice profile card...', vocality_update_name: 'Update name', vocality_profit_calculation: 'Earnings calculation', vocality_reused: 'Reused', vocality_generated: 'Generated', vocality_image_error: 'Image error', vocality_regenerate_required: 'Regeneration required', vocality_pending: 'Pending', vocality_record_intro_first: 'Please record a voice introduction first', vocality_record_sample_first: 'Please record a voice sample first', vocality_regenerate_card: 'Regenerate voice profile card', vocality_generate_card: 'Generate voice profile card', vocality_existing_image_missing: 'The existing card has no official image. Record a new sample and regenerate it before submitting.', vocality_loading_wait: 'Loading the existing card. Please wait.', vocality_login_to_generate: 'Please sign in before generating a card', vocality_generating_wait: 'The card is being generated. Please wait.', vocality_generate_failed: 'Failed to generate the voice profile card', vocality_image_generate_failed: 'Failed to generate the card image. Please try again later.', vocality_generate_success: 'Voice profile card generated', vocality_generate_retry: 'Failed to generate the card. Please try again later.', vocality_data_error: 'Invalid card data. Please regenerate it.', vocality_enter_nickname: 'Please enter a nickname first', vocality_login_to_update: 'Please sign in before updating', vocality_name_update_failed: 'Failed to update the card name', vocality_image_update_failed: 'Failed to update the card image. Please try again later.', vocality_name_updated: 'Card name updated', vocality_name_update_retry: 'Failed to update the card name. Please try again later.', vocality_image_missing: 'The card has no official image. Record a new sample and regenerate it before submitting.', vocality_image_load_failed: 'Failed to load the official card image. Retry or record a new sample to regenerate it.', vocality_generate_first: 'Please generate the official voice profile card first', select_level_first: 'Please select a level', enter_self_introduction: 'Please enter a self-introduction'
  ,vocality_updating: 'Updating', apullc_rules_exact: 'If a friend registers using the invitation code below, I will receive a reward equal to 3% of each top-up they make within 60 days. If a single top-up exceeds 30,000, the reward is calculated using 30,000. For each eligible new user successfully invited, the inviter receives 1,500 membership points. When I have invited 15 registered users, I will receive the permanent event-exclusive Cyber Rebel avatar frame. When a friend registers, they will receive one 50-coin coupon with no minimum spend and a threshold coupon pack worth a total of 100 coins.', apullc_notes_exact: 'Invitation rewards require processing time. Please wait patiently. Only accounts linked to a Taiwan phone number are valid invited users. Invitations created through repeated registration on the same device or by other methods are invalid. If you have any questions, please contact customer service.', search: 'Search', request_failed: 'Request failed', network_error: 'Network error', vocality_audio_read_failed: 'Failed to read the recording. Please record it again.', vocality_reject_not_human: 'No clear human voice was detected. Please record again.', vocality_reject_too_short: 'The voice sample is too short. Please record at least 8 seconds.', vocality_reject_too_noisy: 'The voice sample is too noisy. Please record again in a quiet place.', vocality_reject_tts: 'Synthetic speech was detected. Please use your real voice.', vocality_reject_default: 'The voice sample did not pass verification. Please record again.'
  ,jkoPay: {
    name: 'JKOPAY', retry: 'Check payment again', resultPending: 'Payment pending confirmation',
    success: 'Payment successful', unconfirmed: 'Payment not confirmed', queryFailed: 'Unable to check payment',
    processing: 'Confirming payment', credited: '{asset} has been credited.',
    genericPending: 'Your recharge request was submitted. Bank confirmation usually takes 1–5 minutes.',
    unconfirmedDescription: 'No successful JKOPAY result was found. Please check again later and do not pay twice.',
    queryFailedDescription: 'We cannot check the JKOPAY result right now. Please try again later and do not pay twice.',
    processingDescription: 'Confirming the payment with JKOPAY. Please do not pay twice.',
    nicee: 'Nicee Coins', diamond: 'Diamonds'
  }
};

export default en;
